import { Tooltip } from "@mui/material";
import moment from "moment";

import * as durations from "../constants/durations.constants";

// https://github.com/openlayers/openlayers/pull/10429
// https://github.com/openlayers/openlayers/issues/10273
export const disableHTMLCanvasImageSmoothing = () => {
  // @ts-expect-error no clue how to type this
  HTMLCanvasElement.prototype.__oldGetContext =
    HTMLCanvasElement.prototype.getContext;

  HTMLCanvasElement.prototype.getContext = function (type, options) {
    // @ts-expect-error no clue how to type this
    const context = this.__oldGetContext(type, options);
    if (type === "2d") {
      context.imageSmoothingEnabled = false;
      context.webkitImageSmoothingEnabled = false;
      context.mozImageSmoothingEnabled = false;
      context.msImageSmoothingEnabled = false;
    }
    return context;
  };
};

export const enableHTMLCanvasImageSmoothing = () => {
  // @ts-expect-error no clue how to type this
  if (HTMLCanvasElement.prototype.__oldGetContext) {
    HTMLCanvasElement.prototype.getContext =
      // @ts-expect-error no clue how to type this
      HTMLCanvasElement.prototype.__oldGetContext;
    // @ts-expect-error no clue how to type this
    delete HTMLCanvasElement.prototype.__oldGetContext;
  }
};

export const checkEmailFormat = (email: string) => {
  const re =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const getDateTo = (
  duration:
    | typeof durations.PT24H
    | typeof durations.P7D
    | typeof durations.P1M
    | typeof durations.P1Y,
  dateFrom?: string,
) => {
  if (!dateFrom) return undefined;

  switch (duration) {
    case durations.PT24H:
      return moment(dateFrom).endOf("day").toISOString();
    case durations.P7D:
      return moment(dateFrom).endOf("week").toISOString();
    case durations.P1M:
      return moment(dateFrom).endOf("month").toISOString();
    case durations.P1Y:
      return moment(dateFrom).endOf("year").toISOString();
    default:
      return moment(dateFrom).endOf("day").toISOString();
  }
};

export const tooltipForDisabled = (
  disabled: boolean,
  title: string,
  component: React.ReactNode,
) => {
  if (disabled) {
    return (
      <Tooltip title={title}>
        <span>{component}</span>
      </Tooltip>
    );
  } else {
    return component;
  }
};

export function insertArray(
  array: Array<unknown>,
  startIndex: number,
  insertedArray: Array<unknown>,
) {
  const part1 = array.slice(0, startIndex);
  const part2 = array.slice(startIndex + insertedArray.length);
  return [...part1, ...insertedArray, ...part2];
}
